import React, { Component } from 'react'
import PropTypes from 'prop-types'
// Child Components
import DiscountEntry from './discount-entry'
import DiscountItem from './discount-list-item'
// Other
import Text from 'localize'
import './lang'
import debounce from 'lodash/debounce'
import isEmpty from 'lodash/isEmpty'
import DiscountTypes from '../../../../core/enums/discounts'

const maxNumDiscounts = 2
const allowAddition = list => list && list.length < maxNumDiscounts

class DiscountComponent extends Component {
  static propTypes = {
    actions: PropTypes.object,
    checkDiscountCodeRetrieving: PropTypes.bool,
    currency: PropTypes.object,
    onChange: PropTypes.func
  }

  state = { discounts: [], discountCode: '', isValid: false, hasResponse: false, hasError: false }

  _onRemove = code => {
    const { discounts = [] } = this.state
    const filteredDiscounts = discounts.filter(discount => discount.code !== code)

    const { actions = {}, onChange = () => {} } = this.props
    const { clearDiscountCode = () => {} } = actions

    this.setState(
      {
        discounts: filteredDiscounts
      },
      () => {
        clearDiscountCode()
        onChange(filteredDiscounts)
      }
    )
  }

  _debouncedCheck = debounce(() => {
    const { actions = {} } = this.props
    const { checkDiscountCode = () => {} } = actions
    const { discountCode = '', discounts = [] } = this.state

    if (discountCode && discounts.every(discount => discount.code !== discountCode)) {
      checkDiscountCode(discountCode)
    }
  }, 600)

  _onChange = code => {
    if (!code) {
      this.setState(
        {
          discountCode: '',
          hasResponse: false,
          hasError: false
        },
        () => this.props.actions.clearDiscountCode()
      )
    } else {
      this.setState(
        {
          discountCode: code,
          hasResponse: false,
          hasError: false
        },
        () => this._debouncedCheck()
      )
    }
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    const {
      checkDiscountCodeResponse = {},
      checkDiscountCodeError,
      onChange = () => {},
      persistentData = []
    } = nextProps
    const { discountCode = '' } = prevState
    const hasResponse = discountCode && !isEmpty(checkDiscountCodeResponse)
    const hasError = discountCode && !isEmpty(checkDiscountCodeError)
    const isValid = hasResponse && checkDiscountCodeResponse.is_valid
    let errorCode = ''

    if (persistentData.length && !prevState.discounts.length) {
      // return {
      //   ...prevState,
      //   discounts: persistentData
      // }

      return null
    }

    if (isValid && !hasError) {
      const {
        coupon_type: couponType,
        price_amount: priceAmount,
        percentage_amount: percentageAmount
      } = checkDiscountCodeResponse
      const amount = couponType === DiscountTypes.PRICE ? priceAmount : percentageAmount
      const isDuplicate = (prevState.discounts || []).some(
        discount => discount.code === discountCode || discount.couponType === couponType || (amount && discount.amount)
      )

      if (!isDuplicate) {
        const discounts = [...prevState.discounts, { code: discountCode, couponType, amount }]

        onChange(discounts)

        return {
          ...prevState,
          discounts,
          discountCode: '',
          hasResponse: false,
          hasError: false,
          errorCode: '',
          isValid: false
        }
      } else {
        errorCode = couponType === DiscountTypes.FREE_SHIPPING ? 'only1FreeShipping' : 'only1PriceDiscount'
      }
    }

    return {
      ...prevState,
      hasResponse,
      hasError,
      isValid,
      errorCode
    }
  }

  render () {
    const { checkDiscountCodeRetrieving, currency } = this.props
    const {
      discounts = [],
      discountCode = '',
      isValid = false,
      hasResponse = false,
      hasError = false,
      errorCode = ''
    } = this.state

    const rows = discounts.map((discount, index) => (
      <DiscountItem
        key={index}
        couponType={discount.couponType}
        amount={discount.amount}
        currency={currency}
        onRemove={() => this._onRemove(discount.code)}
      />
    ))

    return (
      <div className='row discount pt-2'>
        <div className='col-12'>
          <span>
            <Text message='modules.cart.components.discount.title' />
          </span>

          <DiscountEntry
            show={allowAddition(discounts)}
            discountCode={discountCode}
            isValid={isValid}
            retrieving={checkDiscountCodeRetrieving}
            hasResponse={hasResponse}
            error={hasError ? 'application' : errorCode}
            onChange={this._onChange}
          />
        </div>
        <div className='col-12'>
          {rows}
        </div>
      </div>
    )
  }
}

export default DiscountComponent
